import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../shared/shared.global-service';
import { selectFolderId } from '../../../store/person/person.selectors';
import { WorkGridItemObject } from '@it2go/types';

@Injectable()
export class PersonMeasuredValuesStore extends ComponentStoreV2Factory {
    folderId = toSignal(globalStore!.select(selectFolderId));
    items = computed<WorkGridItemObject[]>(() => this.data.getWorks()?.items || []);
}
